import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import AddressMap from '../AddressMap/';
import CustomPoi from '../CustomPoi';
import {checkAllowUpdateCustomPoi, updateCustomPoi } from '../../services/poi';
import { updateCustomHotel } from '../../services/hotel';
import showPicker from '../../native/showPicker';
import { show, hide} from '../Loading';
import Toast from '../Toast';
import { getStayTimeText,getStayTimesList } from '../../helpers/poi';

const stayTimes = getStayTimesList();
export default class EditCustomPoi extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      poi_info: props.poi_info,
      showAddressMap: false,
      allowUpdate: false
    };
  }

  render(){
    let { type, backStep, addActionBtnText } = this.props;
    let { showAddressMap, poi_info, allowUpdate } = this.state; 
    let activeIndex = (poi_info.info.stay_agv / 60) || 0;
    let stayTime = getStayTimeText(activeIndex);
    let center = {lat:poi_info.info.lat, lng:poi_info.info.lng};
    return(
      <div id="edit-custom-poi">
        <CustomPoi 
          type={type}
          backStep={backStep}
          poi_info={poi_info}
          center={center}
          stayTime={stayTime}
          addActionBtnText={addActionBtnText}
          allowUpdate={allowUpdate}
          setAddress={this.showAddressMap}
          setStayTime={this.setStayTime}
          onRemove={this.props.onRemove}
          onAdd={this.props.onAdd}
        />
        
        <CSSTransitionGroup
          component="div"
          transitionName="right-in-box"
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}>
          {
            showAddressMap ?
              <AddressMap
                className="right-in-box"
                noFitBoundsFirstTime={true}
                name={this.props.poi_info.info.cn_name}
                center={center}
                handleLeftButtonClick={this.hideAddressMap}
                saveAddress={this.saveAddress}/>
              : null
          }
        </CSSTransitionGroup>
      </div>
    );
  }

  componentWillMount(){
    checkAllowUpdateCustomPoi(this.props.poi_info.poi_uid)
      .then((res)=>{
        if(res && res.allow_update_status){
          this.setState({
            allowUpdate: res.allow_update_status
          });
        }
      })
      .catch((err)=>{

      });
  }

  componentDidMount(){
    let { type } = this.props;
    this.updateCustomItemInfo = type === 'hotel' ? updateCustomHotel : updateCustomPoi;
  }

  hideAddressMap = () =>{
    this.setState({
      showAddressMap: false
    });
  }

  showAddressMap =() =>{
    this.setState({
      showAddressMap: true
    });
  }

  /**
   * 走更新信息流程
   */
  saveAddress = (center)=>{
    this.updateInfo({...center});
  }

  /**
   * 设置游玩时间
   */
  setStayTime = (time)=>{
    let {poi_info} = this.state;
    showPicker({
      activeIndexs: [poi_info.info.stay_agv / 60],
      list: [...stayTimes],
      handleConfirm: (index)=>{
        this.updateInfo({stay_time: index[0]});
      }
    });
  }

  /**
   * @todo 更新poi流程
   * @param {*} query 
   */
  updateInfo(query){
    show();
    let { poi_info } = this.props;
    this.updateCustomItemInfo({
      ...query,
      poi_uid: poi_info.poi_uid
    })
      .then((res)=>{
        hide();
        if(res){
          Toast('更新成功');
          this.setState({
            ...res,
            showAddressMap: false
          });
          this.props.updatePoiTrip(res.poi_info, res.city_info);
        }
      })
      .catch((err)=>{
        console.log(err);
      }); 
  }
}




// WEBPACK FOOTER //
// ./src/components/EditCustomPoi/index.js